<template>
	<div class="template_box PostDetails_template_box">
		<div class="goBack">
			<goBack :page_title="page_title" :params="this.$route.params"></goBack>
		</div>
		<div class="content_box" v-if="Loading">
			<Loading></Loading>
		</div>
		<div class="content_box" v-else>
			<div class="content_box post-details">
				<PostList ref="PostDetailsRef" v-if="LoadingSuccess" :Post_List="recommand_list" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" @operations="operations" @get_commentList="get_commentList"></PostList>
			</div>
		
			<div class="content_box comment_list">
				<CommentList ref="CommentList" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" @operations="operations"></CommentList>
			</div> 
		</div>
	</div>
</template>

<script>
import { post_community_postdetail, post_community_postread } from '@/api/community.js'
import PostList from '../../components/public/PostList.vue'
import CommentList from '../../components/public/CommentList.vue'

export default {
	name: 'post-details',
	
	components: { PostList, CommentList },
	data() {
		return {
			page_title: "",
			postreport: {
				post_id: this.$route.params.post_id,
				reasons: [],  //举报原因 array 必填
				remark: "", //说明 选填
			},
			activeMenu: "recommand", // 默认选中菜单
			page_name: "post-details",
			recommand_list: [],
			Loading: false,
			LoadingSuccess: false,
		};
	},
	
	// 监听
	watch: {
		// "searchText": {
		// 	handler: function (newValue, oldValue) {
		// 		if(this.searchText && this.searchText != ''){
		// 			this.icon_search = false
		// 		}else{
		// 			this.icon_search = true
		// 		}
		// 	},
		// 	deep: true
		// },
	},
	
	created () {
		
	},
	
	// 路由进入可操作数据
	// beforeRouteEnter(to, from, next) {
	// 	console.log('路由进来当前页面beforeRouteEnter');
	// 	next();
	// },
	
	// beforeRouteLeave(to, from, next) {
	// 	console.log('路由正在离开当前页面beforeRouteLeave');
	//    next();
	// },
	
	// 路由进入可操作数据
	activated() {
		console.log('路由进来当前页面activated');
		this.post_community_postdetail();
		this.post_community_postread();
	},
	
	// 路由离开时的钩子函数
	deactivated() {
		console.log('路由正在离开当前页面deactivated');
		// 可以进行一些清理操作，例如取消请求、清除定时器、释放资源等
	},
	
	// beforeCreate() {
		
	// }
	
	mounted() {
		this.post_community_postdetail();
		this.post_community_postread();
   },
	
	methods: {
		//子组件关注操作
		operations(type){
			if(type == 'success'){
				// 操作成功刷新列表数据
				this.post_community_postdetail('HiddeLoading')
				this.$refs.CommentList.set_type_list(); // 如果此时需要立即调用
			}
		},
		
		//回复和评论刷新评论列表
		get_commentList(type){
			if(type == 'success'){
				this.$refs.CommentList.set_type_list(); // 如果此时需要立即调用
			}
		},
		
		//获取帖子详情
		post_community_postdetail(typeName){
			if(this.Loading){ return }
			if(typeName != "HiddeLoading"){
				this.Loading = true
			}
			post_community_postdetail({post_id: this.$route.params.post_id})
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					let arr = []
					res.data.post_type = res.data.type //兼容列表中帖子类型字段
					arr.push(res.data)
					this.recommand_list = arr
					let subjects = res.data.subjects;
					let subjectsStr = subjects ? subjects.map(item => `#${item}`).join(', ') : "";
					this.$setTags.updateMetaDescription(subjectsStr + ' ' + res.data.content || "")
					this.Loading = false
					this.LoadingSuccess = true
				}else{
					this.exception_handling(res, "postreport")
				}
				
				this.$setTags.updateCanonical(this.$router.currentRoute.path);
				// this.$setTags.updateCanonical(`/post-details/${this.$route.params.post_id}`)
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postreport")
		   })
		},
		
		//浏览帖子
		post_community_postread(){
			let post_ids = [
				this.$route.params.post_id
			]
			post_community_postread({ post_ids: post_ids })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					console.log('预览上传成功')
				}else{
					this.exception_handling(res, "postread")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postread	")
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.Loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
	}
};
</script>

<style lang="less" scoped>
	.template_box{
		background-color: #ffffff;
		border-radius: 8px;
	}
	.PostDetails_template_box{
		position: relative;
	}
	.goBack{
		padding: 10px;
	}
	.content_box{
		width: 100%;
		height: 100%;
	}
	
	@media screen and (max-width: 1024px) {
		
	}
</style>
